var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgress2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 20,
    viewBox: "0 0 149 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148 14.5H1V19.5H148V14.5Z",
    fill: "#E8E8E7",
    stroke: "#2E3348",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35645 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65039 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9443 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2383 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5325 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8264 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1204 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4141 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7083 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0022 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2964 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5903 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.884 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1782 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4722 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7664 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0601 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.354 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6479 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9421 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2361 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.53 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.824 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1179 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4121 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7061 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M66 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 0.5V14.5",
    stroke: "#FA1439",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M148 0.5H1V14.5H148V7.5V0.5Z",
    stroke: "#2E3348",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress2);
export default __webpack_public_path__ + "static/media/progress2.b7ec9f91c8225447f0a8cea8f73807d0.svg";
export { ForwardRef as ReactComponent };